export enum Role {


    SmartWaste$SuperAdmin = 'SmartWaste$SuperAdmin',

    SmartWaste$Admin = 'SmartWaste$Admin',

    SmartWaste$User = 'SmartWaste$User',

    Administration$SuperAdmin = 'Administration$SuperAdmin',

    Administration$Admin = 'Administration$Admin',

    Administration$User = 'Administration$User',

    SmartParking$SuperAdmin = 'SmartParking$SuperAdmin',

    SmartParking$Admin = 'SmartParking$Admin',

    SmartParking$User = 'SmartParking$User',


}